import router from './router'
// import store from './store'
import { getToken, setCookie, getCookie } from '@/utils/auth' // 验权

// const dontNeedWxList = ['/course/preview', '/course/courseDetail']// 不需要微信授权白名单
// const canShareList = ['/course/courseDetail']// 允许分享白名单
const dontNeedLoginList = [
  '/login/index',
  '/clean',
  '/gene/index',
  '/juan',
  '/juan/answer',
  '/juan/from',
  '/url',
  '/gene/index',
  '/appoint/index',
  '/globel/success',
  '/globel/fail',
  '/globel/appoint',
  '/globel/yx-card',
  '/globel/zx-vote',
  '/question/ask',
  '/question/ask-detail',
  '/qx-question/index',
  '/qx-question/detail',
  '/nianjian-zan/index',
  '/nianjian-zan/detail',
  '/globel-page/xrbp',
  '/globel-page/xrbp202008',
  '/globel-page/qi',
  '/globel-page/bjsd',
  '/globel-page/bjsd-ad',
  // 有奖答题
  '/competition/ask',
  '/competition/ask-detail',
  '/competition/modal',
  '/competition/lottery',
  '/competition/fraction',
  '/competition/submit',
  // 有奖答题
  // 知识之星大比拼
  '/assess/ask',
  '/assess/ask-detail',
  '/assess/modal',
  '/assess/user-info',
  '/assess/score',
  // 知识之星大比拼
  // 2026开门红•云催繳线上知识竞赛
  '/collection/ask',
  '/collection/detail',
  '/collection/modal',
  '/collection/user',
  '/collection/score',
  // 2026开门红•云催繳线上知识竞赛
  // 24.8 新生儿线索收集
  '/clue/invite',
  '/clue/assist',
  '/clue/poster',
  '/clue/inviteEnd',
  '/clue/invited',
  '/clue/success',
  '/clue/invitedEnd',
  // 24.8 新生儿线索收集
  // 保险 告知函
  '/insurance/invite',
  '/insurance/poster',
  '/insurance/assist',
  '/insurance/statistics',
  // 保险 告知函
  // 续签
  '/renewal/index',
  // 续签
  // 理赔调查问卷
  '/claims/index',
  // 理赔调查问卷
  // 2025 3.8 女神节活动
  '/goddess/invited',
  '/goddess/success',
  '/goddess/invitedEnd',
  // 2025 女神节活动
  // 2025 在线缴费抽奖
  '/payment-draw',
  // 2025 在线缴费抽奖
  // 2025 5.28 端午节活动
  '/dragon-boat',
  // 2025 5.28 端午节活动
  // 全国知识竞赛
  '/assessment/ask',
  '/assessment/ask-detail',
  '/assessment/user-info',
  '/assessment/score',
]// 不需要登录白名单

setCookie('theurl', window.location.href)
router.beforeEach((to, from, next) => {
  // const cid = to.query.cid
  const cid = 'pQR7mpD_wseH-S2v'
  // const cid = 'N-QLoWElKA3hNwZ-'
  // const cid = 'f4h9grBgFeRBo7yj'
  if (cid !== null && cid !== undefined && cid !== '') {
    setCookie('cid', cid)
  }
  // getOpIdCommon(window.location.href, to) // 禁止微信分享功能
  if (getToken() && getCookie('groupid')) { // 判断是否有token，且有群组
    if (to.path === '/login/index') {
      // 如果是已登录情况访问登录页
      next('/') // 跳转首页
    } else {
      // 如果有token则权限存在，继续执行
      next()
    }
  } else { // 否则检索是否在白名单，如果不在就跳转登录页
    // next()
    if (dontNeedLoginList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next('/login/index') // 否则全部重定向到登录页
    }
  }
})

router.afterEach((to, from, next) => {
  // needWx(to, from, next)
})



// WEBPACK FOOTER //
// ./src/permission.js